import React from 'react'
import CounterPart from '../common/CounterPart';
import countryIcon1 from "../images/netherlands.png"
import countryIcon2 from "../images/uk.png"
import countryIcon3 from "../images/gulfnation.png"
import countryIcon4 from "../images/india.png"
import { useTranslation } from 'react-i18next';

const DomainExperts = () => {
    const {t} = useTranslation();
    const data = [
        { image: countryIcon1, num: t("netherlands"), name: t("netherlands_desc") },
        { image: countryIcon2, num: t("uk_singapore"), name: t("uk_singapore_desc") },
        { image: countryIcon3, num: t("gulf_nations"), name: t("gulf_nations_desc") },
        { image: countryIcon4, num: t("india"), name: t("india_desc") },
    ];

    return (
        <div className="">
            <CounterPart data={data} title={t("domain_experts")} subtitle={t("domain_experts_desc")} />
        </div>
    )
}

export default DomainExperts